import React from 'react';
import PropTypes from 'prop-types';
import PagerButton from '../PagerButton';
import './styles.styl';

const FrontPage = ({ data }) => {
  return (
    <div className="front-page">
      <div className="front-page__background">
        <div
          className="front-page__background--desktop"
          style={{
            backgroundImage: `url(${data.foregroundImg}), url(${
              data.backgroundImg
            })`
          }}
        />
        <div
          className="front-page__background--mobile"
          style={{ backgroundImage: `url(${data.foregroundImg})` }}
        />
      </div>
      <div className="front-page__content">
        <img src={data.logo} alt="" className="front-page__logo" />
        <h1 className="front-page__title">{data.title}</h1>
        <p className="front-page__subtitle">{data.subTitle}</p>
        <div className="front-page__intro">{data.intro}</div>
        <PagerButton />
        <img
          src={data.foregroundImg}
          alt={'Be Vape Free'}
          className={'front-page__content--mobile-image'}
        />
      </div>
    </div>
  );
};

FrontPage.defaultProps = {};

FrontPage.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    subTitle: PropTypes.string,
    intro: PropTypes.node
  })
};

export default FrontPage;



// WEBPACK FOOTER //
// ../core/src/components/FrontPage/FrontPage.js